<form class="modal-body" [formGroup]="form" (ngSubmit)="next()" novalidate>
  <ng-container *ngIf="currentStep === ModalStep.OtpCode">
    <p class="centermodal__title">{{ 'confirmOtpModal.otpStep.title' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'confirmOtpModal.otpStep.description' | translate }}</p>
    <!--    <p class="centermodal__title">{{ 'mfaModal.titles.confirm' | translate }}</p>-->
    <!--    <p class="centermodal__description text-left pt-2">{{ 'mfaModal.descriptions.confirm' | translate }}</p>-->

    <label class="field__holder mb-5" [appFormControlWrap]="form.get('otp')">
      <input type="tel" class="field" formControlName="otp" name="otp" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
      <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
    </label>

    <button type="button" class="centermodal__link centermodal__link--margin-2" [disabled]="isLoading" (click)="currentStep = ModalStep.MfaSelect" *ngIf="currentStep === ModalStep.OtpCode">
      {{ 'confirmOtpModal.otpStep.trySomethingElse' | translate }}
    </button>
  </ng-container>

  <ng-container *ngIf="currentStep === ModalStep.MfaSelect">
    <p class="centermodal__title">{{ 'confirmOtpModal.mfaSelectStep.title' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'confirmOtpModal.mfaSelectStep.description' | translate }}</p>

    <div class="centermodal__form">
      <label class="field__holder radio-option" *ngFor="let item of mfaOptions">
        <input type="radio" name="mfaType" formControlName="mfaType" [value]="item.type" />
        {{ item.description | translate }}
      </label>
    </div>

    <button type="button" class="centermodal__link centermodal__link--margin-2" [disabled]="isLoading" (click)="currentStep = ModalStep.RecoveryCode" *ngIf="currentStep === ModalStep.MfaSelect">
      {{ 'auth.lostMfa' | translate }}
    </button>
  </ng-container>

  <ng-container *ngIf="currentStep === ModalStep.RecoveryCode">
    <p class="centermodal__title">{{ 'confirmOtpModal.otpRecoveryStep.title' | translate }}</p>
    <p class="centermodal__description text-left pt-2">{{ 'confirmOtpModal.otpRecoveryStep.description' | translate }}</p>

    <div class="centermodal__form">
      <label class="field__holder" [appFormControlWrap]="form.get('recoveryCode')">
        <input type="text" class="field" formControlName="recoveryCode" name="recoveryCode" autocomplete="none" required />
        <span class="field__placeholder">{{ 'confirmOtpModal.otpRecoveryStep.input' | translate }}</span>
      </label>
    </div>
  </ng-container>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="back()">{{ 'button.back' | translate }}</button>
    <button type="submit" class="btn-M btn-filled" [disabled]="isLoading">{{ 'button.forward' | translate }}</button>
  </div>
</form>
